<template>
  <div class="listmain ">
    <h1 class="firTitle">错误响应信息</h1>

<p>
	<b class="ql-author-7802039 ql-size-9">错误响应</b>
</p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.XXXX",
			  "name":"ErrorResponse",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "deviceId":"abcde12345",
			  "errorCode":"DEVICE_NOT_SUPPORT_FUNCTION",
			  "message":"device not support"
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">错误响应header协议中name为ErrorResponse</span>
	  </p>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">错误响应payload 协议如下</span>
	  </p>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  参数
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  deviceId
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设备ID
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  errorCode
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  错误码，详见 2.2章节
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  message
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  错误信息
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <br>
	  <p>
		  <b class="ql-author-7802039 ql-size-9">异常响应的信息列表</b>
	  </p>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  错误码 errorCode
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  错误码说明
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  对应message
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  INVALIDATE_CONTROL_ORDER
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  控制指令不正确
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  invalidate control order
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SERVICE_ERROR
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  服务异常
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  服务错误原因
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  DEVICE_NOT_SUPPORT_FUNCTION
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设备不支持该操作
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  device not support
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  INVALIDATE_PARAMS
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  请求参数有误
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  invalidate params
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  DEVICE_IS_NOT_EXIST
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设备未找到
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  device is not exist
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  IOT_DEVICE_OFFLINE
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设备离线状态
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  device is offline
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  ACCESS_TOKEN_INVALIDATE
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  access_token 无效/失效
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  access_token is invalidate
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <span>
		  <br>
<p>
	<span class="ql-author-7802039 ql-size-9">注意事项：</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">1.请求响应response header 的Content-Type 头部需要是 application/json 格式</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">2. OrionOS云端请求厂商服务接口目前设置的超时时间为2秒，如果出现服务不可用的情况，请接入方进行优化</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">3. messageId 是不重复的消息id</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">4. 通用协议的请求都是POST请求</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">5.app 上显示产品icon有问题时请注意icon链接大小是160*160</span>
</p>
</span>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 30px;
      font-size: 16px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
      width: 100%;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/errorMessage/Zn_err_message.vue